import React from 'react';
import { IconButton } from '@mui/material';
import { VirtualTableHeadCell } from "../../virtualized-table/types";
import { SelectColumnFilter } from '../../virtualized-table/components/filter';
import DownloadFile from "../download-file";
import CancelIcon from '../../../assets/icons/cancel-icon';

export const uploadCommunicatorFilesHeaderCells: VirtualTableHeadCell[] = [
    {
        accessor: 'fileName',
        Header: 'File Name',
    },
    {
        accessor: 'status',
        Header: 'Status',
    }, 
    {
        accessor: 'actions',    
        Header: 'Remove',
        component: ({row}: any) => (
            <IconButton
            style={{marginTop: '-8px'}}
            onClick={row.values.actions.remove}
            aria-label="delete"
            size="large"
            >
                <CancelIcon />
            </IconButton>
        )
    }
];

export const uploadCommunicatorFilesSortableAccessors = {
    fileName: true,
};

export const communicatorFilesHeadCells: VirtualTableHeadCell[] = [
    {
        accessor: 'fileName',
        Header: 'File Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'createdTime',
        Header: 'Uploaded Date',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'userId',
        Header: 'User ID',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'id',
        Header: 'SHA',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'downloadIcon',
        Header: 'Download',
        component: DownloadFile,
    },
];

export const communicatorFilesSortableAccessors = {
    fileName: true,
    createdTime: true,
    userId: true,
};
